import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { STATUS } from '../../functions/visibility';

/**
 * Formats a portfolio's benchmark name ready to be displayed to user. Prepends with 'Relative to' if
 * not a hidden or unknown benchmark.
 * @param {Object} portfolioData
 * @returns {String}
 */
function formatBenchmarkName(portfolioData) {
    const benchmark =
        portfolioData?.benchmarkName ?? 'Benchmark Name Unavailable';

    if (benchmark === '') {
        return 'Benchmark Name Unavailable';
    }
    if (
        benchmark !== 'Hidden Benchmark' &&
        benchmark !== 'Benchmark Name Unavailable'
    ) {
        return `Relative to ${benchmark}`;
    }
    if (
        benchmark === 'Hidden Benchmark' &&
        portfolioData?.status !== STATUS.hidden
    ) {
        //Prevent missing benchmark attributes showing as hidden, only an issue while not all portfolios have a benchmark name.
        return 'Benchmark Name Unavailable';
    }
    return benchmark;
}

/**
 * Renders a Typography element displaying a portfolio's formatted benchmark name
 *
 * @component
 * @param {Object} portfolioData - given portfolio's attributes
 * @param {Object} typographyProps - props passed to Typography element
 * @returns {React.ReactElement}
 */
export const BenchmarkName = ({ portfolioData, typographyProps }) => (
    <Typography {...typographyProps} data-analyticsid='benchmark-name'>
        {formatBenchmarkName(portfolioData)}
    </Typography>
);

BenchmarkName.propTypes = {
    portfolioData: PropTypes.object,
    typographyProps: PropTypes.object
};
